import React from 'react';
import PropTypes from 'prop-types';
import TableSortIconElement from "./TableSortIcon";
var propTypes = {
  direction: PropTypes.oneOf(['up', 'down'])
};
var defaultProps = {
  direction: 'down'
};
export default function TableSortIcon(props) {
  return React.createElement(TableSortIconElement, props);
}
TableSortIcon.propTypes = propTypes;
TableSortIcon.defaultProps = defaultProps;